import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-sutton',
    templateUrl: './page-sutton.component.html',
    styleUrls: ['./page-sutton.component.css'],
    standalone: false
})
export class PageSuttonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
